<div>
    <div class="search-box">
        <div class="container-box">
            <div class="row search-header">
                <div class="col-auto">
                    <mat-icon svgIcon="search"></mat-icon>
                </div>
                <span class="col-auto">{{'dpo.i18n.consultation.search.header' | translate}}</span>
            </div>
        </div>
        <div class="container-box">
            <form>
                <div class="container">
                    <div>
                        <div class="row criteria-box">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 label ">
                                {{'dpo.i18n.label.rrdi' | translate}}
                            </div>
                            <input class="col-12 col-sm-6 col-md-4 col-lg-3 field input" type="text" [(ngModel)]="rrdi"
                                name="rrdi"
                                [disabled]="(queryParams && queryParams[DPO_CONSTANT.QP_RRDI_CODE]) ? rrdiAutoCompleteForm.disable() : rrdiAutoCompleteForm.enable()"
                                [matAutocomplete]="rrdiAutoComplete" [formControl]="rrdiAutoCompleteForm" />
                            <mat-autocomplete #rrdiAutoComplete="matAutocomplete">
                                <mat-option *ngFor="let rrdiCode of rrdiAutoCompleteFilteredOptions | async"
                                    [value]="rrdiCode">
                                    {{ rrdiCode }}
                                </mat-option>
                            </mat-autocomplete>
                        </div>
                        <div class="row criteria-box">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 label ">
                                {{'dpo.i18n.label.vin' | translate}}
                            </div>
                            <input class="col-12 col-sm-6 col-md-4 col-lg-3 field input" type="text" [(ngModel)]="vin"
                                name="vin" />
                        </div>
                        <div class="row criteria-box">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 label ">
                                {{'dpo.i18n.label.backetFolderNumber' | translate}}</div>
                            <input class="col-12 col-sm-6 col-md-4 col-lg-3 field input" type="text"
                                [(ngModel)]="basketFolderNumber" name="basketFolderNumber" />
                        </div>
                        <div class="row criteria-box">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 label ">
                                {{'dpo.i18n.label.subscription.status' | translate}}</div>
                            <select class="col-12 col-sm-6 col-md-4 col-lg-3 field input select"
                                [(ngModel)]="subscriptionStatus" name="subscriptionStatus">
								<!-- CAP-20457: Translation added for select option -->
                                <option value="0" selected>--{{'dpo.i18n.consultation.ddl.option.sel' | translate}}--</option>
                                <option *ngFor="let subscriptionOption of subscriptionOptions"
                                    value="{{subscriptionOption.status}}">{{subscriptionOption.label | translate}}</option>
                            </select>
                             <!--CAP-26096 : Start - Transaction Refrence lable and text box-->
                             <div class="col-12 col-sm-6 col-md-4 col-lg-3 label ">
                                {{'dpo.i18n.table.header.transFeatureId' | translate}}</div>
                                <input class="col-12 col-sm-6 col-md-4 col-lg-3 field input" type="number"
                                pattern="/^[0-9]+$/"
                                (keyup)="validateTransactionalFeatureId($event.target.value) ? true : ($event.target.value = transactionalFeatureIdValue)"
                                [(ngModel)]="transFeatureId" name="transFeatureId" />
                    		<!--CAP-26096 : End-->
                        </div>
                        <div class="row criteria-box">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 label ">
                                {{'dpo.i18n.label.subscription.daterange' | translate}}</div>
                            <div class="col-12 col-sm-6 col-md-4 col-lg-3 date-container">
                                <div class="row">
                                    <div class="col field input">
                                        <input matInput [matDatepicker]="fromDatepicker" [max]="maxDate"
                                            placeholder="{{'dpo.i18n.date.picker.placeholder' | translate}}"
                                            [(ngModel)]="fromSubscriptionDate" name="fromSubscriptionDate">
                                        <mat-datepicker-toggle matSuffix [for]="fromDatepicker">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #fromDatepicker disabled="false"></mat-datepicker>
                                    </div>
                                    <div class="col offset-1 field input">
                                        <input matInput [matDatepicker]="toDatepicker" [max]="maxDate"
                                            placeholder="{{'dpo.i18n.date.picker.placeholder' | translate}}"
                                            [(ngModel)]="toSubscriptionDate" name="toSubscriptionDate">
                                        <mat-datepicker-toggle matSuffix [for]="toDatepicker">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #toDatepicker disabled="false"></mat-datepicker>
                                    </div>
                                </div>
                            </div>
                            <!--CAP-26096 : Start-Billable Operation lable and check box-->
                            <div class="col-13 col-sm-7 col-md-5 col-lg-4 label ">
                                <mat-icon [ngStyle]="{'color':'blue'}"
                                     matTooltip="{{'dpo.i18n.icon.info.billable'| translate}}"
                                     matTooltipPosition="below" matTooltipClass="tooltip">info
                                 </mat-icon>
                                {{'dpo.i18n.consultation.lable.billable' | translate}}</div>
                                <input id="col-13 col-sm-7 col-md-5 col-lg-4 field input" type="checkbox"
                                [(ngModel)]="isBillable" name="isBillable" />   
                            <!--CAP-26096 : End-->
                        </div>
                    </div>
                    <div class="search-button">
                        <div class="row justify-content-center">
                            <button class="btn" type="submit" (click)="search()">
                                <div>
                                    <mat-icon svgIcon="search"></mat-icon>
                                </div>
                                <span>{{'dpo.i18n.consultation.button.search' | translate}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="result-box" [hidden]="!(subscriptionList && subscriptionList.length > 0)">
        <div class="container-box subscribed-counter">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-4">
                    <div class="row justify-contant-start">
                        <div class="col-1">
                            <mat-icon svgIcon="description"></mat-icon>
                        </div>
                        <div class="col">
                            <span>{{'dpo.i18n.consultation.subscribed.accuitedServicesNumber' | translate}}</span>
                        </div>
                    </div>
                    <div class="row justify-contant-end">
                        <div class="col subscription-count">
                            <span>{{searchResult.countAquittedService}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4">
                    <div class="row justify-contant-start">
                        <div class="col-1">
                            <mat-icon svgIcon="description"></mat-icon>
                        </div>
                        <div class="col">
                            <span>{{'dpo.i18n.consultation.subscribed.instantiatedServicesNumber' | translate}}</span>
                        </div>
                    </div>
                    <div class="row justify-contant-end">
                        <div class="col subscription-count">
                            <span>{{searchResult.countInstantiatedService}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-4">
                    <div class="row justify-contant-start">
                        <div class="col-1">
                            <mat-icon svgIcon="description"></mat-icon>
                        </div>
                        <div class="col">
                            <span>{{'dpo.i18n.consultation.subscribed.tluExceededNumber' | translate}}</span>
                        </div>
                    </div>
                    <div class="row justify-contant-end">
                        <div class="col subscription-count">
                            <span>{{searchResult.countTluExceeded}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-box">
            <div class="row">
                <div class="col-auto">
                    <mat-icon svgIcon="shopping_cart"></mat-icon>
                </div>
                <div class="col-auto">
                    <span>{{'dpo.i18n.consultation.prestations' | translate}}</span>
                </div>
                <div class="col-auto">
                    <div class="result-count"><span>{{subscriptionList.length}}</span></div>
                </div>
            </div>
            <div class="mat-elevation-z8" style="overflow-x:scroll;">
                <table id="searchResultTable" mat-table [dataSource]="dataSource" matSort #sort="matSort" aria-describedby="searchResultTable">

                    <!-- RRDI Column -->
                    <ng-container matColumnDef="rrdi">
                        <th id="rrdi" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.rrdi' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.rrdi}} </td>
                    </ng-container>

                    <!-- VIN Column -->
                    <ng-container matColumnDef="vin">
                        <th id="vin" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.vin' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.vin}} </td>
                    </ng-container>

                    <!-- Prestation Column -->
                    <ng-container matColumnDef="prestation">
                        <th id="prestation" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.prestation' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.prestation | translate}} </td>
                    </ng-container>

                    <!-- ECU Column -->
                    <ng-container matColumnDef="ecu">
                        <th id="ecu" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.ecu' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.ecu}} </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="subscriptionLabel">
                        <th id="subscriptionLabel" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.status' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.subscriptionLabel | translate}} </td>
                    </ng-container>

                    <!-- Subscription Date Column -->
                    <ng-container matColumnDef="subscriptionDate">
                        <th id="subscriptionDate" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.subscription.date' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.subscriptionDate | date}} </td>
                    </ng-container>

                    <!-- Basket Folder Number Column -->
                    <ng-container matColumnDef="basketFolderNumber">
                        <th id="basketFolderNumber" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.backetFolderNumber' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.basketFolderNumber}} </td>
                    </ng-container>
                    <!-- CAP-26096 :Start- Added two columns billable and Transaction Reference-->
                    <ng-container matColumnDef="billable">
                        <th id="billable" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.billable' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.billable | translate}} </td>
                    </ng-container>
                    <!-- CAP-26096 :End -->
                    <!-- CAP-29963 :POUDG-8878: Start- Added columns ServiceContract-->
                    <ng-container matColumnDef="serviceContract">
                        <th id="billable" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.serviceContract' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.serviceContract | translate}} </td>
                    </ng-container>
                    <!-- CAP-29963 :End -->
                    <!-- CAP-26096 :Start- Added columns Transaction Reference-->
                    <ng-container matColumnDef="transFeatureId">
                        <th id="transFeatureId" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{'dpo.i18n.table.header.transFeatureId' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.tranFeatureId}} </td>
                    </ng-container>
                    <!-- CAP-26096 :End -->
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th id="action" mat-header-cell *matHeaderCellDef> {{'dpo.i18n.table.header.action' | translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <button class="btn" type="submit" (click)="prepareDialogBoxData(element.subscriptionId)">
                                <div>
                                    <mat-icon svgIcon="control_point"></mat-icon>
                                </div>
                                <span>{{'dpo.i18n.consultation.button.details' | translate}}</span>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50, 100]" showFirstLastButtons></mat-paginator>
            </div>
            <div class="action-button">
                <button class="btn" (click)="export()"
                    *ngIf="subscriptionList && subscriptionList.length > 0">{{'dpo.i18n.consultation.button.export' | translate}}</button>
            </div>
        </div>
    </div>
</div>